module.exports = __webpack_public_path__ + "img/closed.ac88ead5.svg";